import { useEffect, useRef, useState } from 'react';
import { VideoJsPlayer } from 'video.js';
import { IconCaptionSwitch } from '../../../icons';
import { PlayerControlButton } from '../styles';
import UsePlayerProps from '../../../Store/usePlayerProps';
import theme from '../../../theme';
import IconCaptionOff from '../../../icons/IconCaptionOff';
import { findCaptionLabel } from '../PlayerServices';

const ControlBarCaptionSwitch = ({ player }:
  {
    player: VideoJsPlayer
  }) => {
  const [captionState, setCaptionState] = useState<'on' | 'off'>('off');
  const prevCaptionIndex = UsePlayerProps((state) => state.playerState.captionState.prevCaptionIndex);
  const setPlayerState = UsePlayerProps((state) => state.setPlayerState);
  const playerState = UsePlayerProps((state) => state.playerState);
  const [isMobile, setIsMobile] = useState(false);

  const resizeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    handleMobileBreakpoint();
    window.addEventListener('resize', throttledHandle, { passive: true });
    return () => {
      window.removeEventListener('resize', throttledHandle);
      if (resizeTimerRef.current) {
        clearTimeout(resizeTimerRef.current);
        resizeTimerRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCaptionState(playerState.captionState.selectedCaptionLang.lang === 'off' ? 'off' : 'on');
  }, [playerState.captionState.selectedCaptionLang.lang]);

  const throttledHandle = () => {
    if (resizeTimerRef.current !== null) return;
    resizeTimerRef.current = setTimeout(() => {
      handleMobileBreakpoint();
      resizeTimerRef.current = null;
    }, 100);
  };

  const handleMobileBreakpoint = () => {
    setIsMobile(Number(theme.breakpoints.md) > Number(window.innerWidth));
  };

  const handleCaptionChange = () => {
    setCaptionState(() => (captionState === 'off' ? 'on' : 'off'));
    if (captionState === 'on') {
      player.textTracks().tracks_.forEach((elem) => {
        elem.mode = 'disabled';
      });
      setPlayerState({
        ...playerState,
        captionState: {
          prevCaptionIndex,
          selectedCaptionLang: {
            lang: 'off',
            label: 'خاموش',
          },
        },
      });
    } else  {
      const _index =  prevCaptionIndex !== -1 ?  prevCaptionIndex : 1;
      player.textTracks().tracks_[_index].mode = 'showing';
      setPlayerState({
        ...playerState,
        captionState: {
          prevCaptionIndex: _index,
          selectedCaptionLang: {
            lang: player.textTracks().tracks_[_index].language,
            label: findCaptionLabel(player.textTracks().tracks_[_index].language),
          },
        },
      });
    }
  };
  return (
    <PlayerControlButton
      size="semiLarge"
      icon={captionState === 'off' ? <IconCaptionOff/> : <IconCaptionSwitch/>}
      onClick={() => handleCaptionChange()}
      mr={isMobile ? 0.5 : 2}
    />
  );
};

export default ControlBarCaptionSwitch;
